export default __webpack_public_path__ + "static/media/termsCondition.4b548c74.pdf";